import Home from '../views/home/index.vue'
import Solutions from '../views/solution/solutions.vue'
// import Conferences from '../views/conference/conferences.vue'
import Join from '../views/joinus/join.vue'
import About from '../views/aboutus/about.vue'
import Interface from '../views/interface/interface.vue'
import  Details from '../views/details/details.vue'
const routers = [
    {
        path: '*',
        name: "index",
        component: Home,
        redirect: '/'
    },
    {
        path: "/",
        name: "index",
        component: Home
    },
    {
        path: "/solution",
        name: "solution",
        component: Solutions
    },
    // {
    //     path: "/conference",
    //     name: "conference",
    //     component: Conferences
    // },
    {
        path: "/aboutus",
        name: "aboutus",
        component: About
    },
    {
        path: "/interface",
        name: "interface",
        component: Interface
    },
    {
        path: "/joinus",
        name: "joinus",
        component: Join
    },
    {
        path: "/details",
        name: "details",
        component: Details
    }
]
export default routers
